import React, { useEffect, useState } from 'react';
import { IconHotelService }           from '@tabler/icons';
import { CSelector }                  from '@core/components/common/CSelector';
import useIsMounted                   from '@hooks/use-is-mounted';
import { useBookingState } from "@core/providers/BookingStateProvider";


export const GuestCountSelector: React.FC = () => {

    const isMounted = useIsMounted();

    const {
        setGuestsCount,
        getGuestLimit
    } = useBookingState();

    const [initialCount, setInitialCount] = useState(getGuestLimit().length.toString());

    const getDefaultRows = getGuestLimit()?.map((item, idx) => {

        const row = item?.count === 1 ? `${item?.count} guest` : `${item?.count} guests`

        return {
            label: row,
            value: item?.count.toString()
        };

    });

    useEffect(() => {

        setGuestsCount(parseInt(initialCount, 10));

    }, []);

    return isMounted && (
        <CSelector
            data={ getDefaultRows }
            initialState={initialCount}
            clearable={true}
            placeholder="Select guests"
            icon={<IconHotelService size={24} stroke={0.6}/>}
            onChange={(value) => {
                setGuestsCount(parseInt(value, 10));
                setInitialCount(value);
            }}
        />
    )

}
